<template>
  <div class="distribute-analysis-main-container" v-loading="loading.initLoading">
    <div class="header">
      <div class="left">
        <span class="back" v-if="!!formComponent.boardId" @click="handleBack">
          <icon name="chevron-left" />
        </span>
        <!--<div class="tit">{{ headTitle }}</div>-->
        <t-breadcrumb style="margin-right: 20px">
          <t-breadcrumb-item>{{ headTitle }}</t-breadcrumb-item>
        </t-breadcrumb>
        <div class="mdRemod">
          <img :src="bookHref" style="margin-right: 5px" alt="" />
          <a href="https://docs.qq.com/doc/DS3pWb1dVZ1NjQmpF" target="_blank">说明文档</a>
        </div>
        <!--<new-guide-trigger class="new-guide-trigger" @click="handleStartGuide"></new-guide-trigger>-->
      </div>
      <div class="right">
        <t-button variant="outline" @click="handleOpenSave">
          <icon name="save" slot="icon" />
          保存
        </t-button>
      </div>
    </div>

    <my-card v-loading="loading.fetchFormOption">
      <div slot="header" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析条件</div>
        </div>
        <div class="right">
          <t-switch size="small" v-model="showAnalysisConditions"></t-switch>
          <span style="margin-left: 10px; font-size: 12px">{{ showAnalysisConditions ? '展开' : '收起' }}</span>
        </div>
      </div>

      <div class="form" v-show="showAnalysisConditions">
        <event-model
          v-model="formValue.eventModel"
          :eventList="formOption.eventList"
          :conditionPropertyOptions="formOption.conditionPropertyOptions"
          :conditionOperatorOptions="formOption.conditionOperatorOptions"
        />

        <distribute-region v-model="analysisDataShowInfo.distributionRegion" />

        <div class="new-guide-step-3">
          <form-item label="全局筛选" class="global-filter">
            <div style="display: flex; align-items: center">
              <span class="global-filter-index">1</span>
              <t-input
                v-model="formValue.globalFilterName"
                style="margin-right: 12px; width: 200px"
                @blur="handleGlobalFilterNameChange"
              ></t-input>
              <t-button @click="handleAddGlobalFilterItem" variant="outline" style="font-size: 12px">
                <icon name="add" slot="icon"></icon>
                筛选项
              </t-button>
            </div>

            <template v-slot:extraLine v-if="formValue.conditionModels && formValue.conditionModels.length">
              <div class="filter">
                <ConditionFilter
                  style=""
                  v-if="formOption.conditionPropertyOptions.length && formOption.conditionOperatorOptions.length"
                  :filter-type.sync="formValue.connectors"
                  :filter-list="formValue.conditionModels"
                  :condition-operator-options="formOption.conditionOperatorOptions"
                  :condition-property-options="formOption.conditionPropertyOptions"
                />
              </div>
            </template>
          </form-item>
        </div>
        <form-item class="row-item" label="分组展示维度">
          <div style="display: flex">
            <t-select
              v-model="analysisDataShowInfo.groupPropertyType"
              @change="onPropertyTypeChange"
              placeholder="请选择"
              style="width: 120px"
            >
              <t-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in formOption.groupPropertyTypeOptions"
                :key="index"
              ></t-option>
            </t-select>
            <event-and-property-selector
              v-if="analysisDataShowInfo.groupPropertyType !== -1"
              v-model="analysisDataShowInfo.groupEventAndProp"
              :all-event-property="formOption.allEventProperty"
              :filter-events="allGroupFilterEvent"
              :filter-property-type="analysisDataShowInfo.groupPropertyType"
              :formatOptionLabelFunc="getGroupOptionLabelFormat"
              :format-option-value-func="getGroupOptionValueFormat"
              :placeholder="groupEventPropPlaceholder"
              style="margin-left: 10px"
              class="event-and-property-selector"
              @change="handleGroupEventAndPropChange"
            ></event-and-property-selector>
          </div>
        </form-item>
        <div style="margin-top: 20px">
          <t-button :loading="loading.fetchData" @click="handleQueryClick" style="font-size: 12px; width: 80px">
            查询
          </t-button>
          <t-button variant="outline" @click="handleReset" style="font-size: 12px; width: 80px">重置</t-button>
        </div>
      </div>
    </my-card>

    <my-card class="section-chart">
      <div slot="header" class="title" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析图表</div>
        </div>
        <div class="right">
          <t-select
            v-model="analysisDataShowInfo.chartShowType"
            placeholder="请选择"
            style="font-weight: normal"
            v-if="formValue.chartType === 'trend'"
          >
            <t-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in formOption.chartShowOptions"
              :key="index"
            ></t-option>
          </t-select>
        </div>
      </div>
      <div class="operation-cont">
        <div class="operation-left">
          <t-select
            v-model="analysisDataShowInfo.timeUnit"
            placeholder="请选择"
            class="operation-item"
            @change="handleChangeTimeUnit"
            :options="filterTimeUnitOptions"
          ></t-select>
          <el-date-picker
            v-model="analysisDataShowInfo.date"
            :type="dataPickerType"
            range-separator="至"
            size="small"
            :clearable="false"
            :picker-options="formOption.datePickerOptions"
          ></el-date-picker>
          <t-divider layout="vertical" style="height: 32px" />
          <div class="operation-label">展现形式</div>
          <t-select
            v-model="formValue.chartType"
            placeholder="请选择"
            class="operation-item"
            @change="handleChangeChartType"
          >
            <t-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in formOption.chartTypeOptions"
              :key="index"
            ></t-option>
          </t-select>
        </div>
      </div>
      <div class="distribute-data-chart-cont" v-if="analysisData">
        <distribute-data-chart
          :analysis-data="analysisData"
          :chartType="formValue.chartType"
          :chart-show-type="analysisDataShowInfo.chartShowType"
        />
      </div>
      <noData v-else />
    </my-card>

    <my-card class="section-table">
      <div slot="header" class="title">
        <div class="title-left">数据详情</div>
        <div class="title-right">
          <icon style="width: 16px; height: 16px; margin-right: 10px" name="download" @click="exportData"></icon>
        </div>
      </div>
      <distribute-data-table :analysis-data="analysisData" :chartType="formValue.chartType" v-if="analysisData" />
      <noData v-else />
    </my-card>

    <save-action
      v-if="showBookmarkModal"
      :loading="loading.submitting"
      :board-info="boardInfo"
      :form-data-component="formComponent"
      :form-data-bookmark="formBookmark"
      @onClose="showBookmarkModal = false"
      @onSaveBookmark="handleSaveBookmark"
      @onSaveComponent="handleSaveComponent"
    ></save-action>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import lodash, { pick } from 'lodash';
import XLSX from 'xlsx';
import FormItem from './components/form-item.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';
import DateRangePicker from '@/components/analysis/date-range-picker.vue';
import noData from '@/components/common/no-data-card.vue';
import SaveAction from './components/save.vue';
import bookHref from '@/assets/images/booklistHref.png';
import {
  getAllProperty,
  getEventList,
  getConditionOperator,
  saveAsBookmark,
  getBookmarkDetail,
  getDistributePollingId,
  getDistributePollingData,
  getAllEventProperty,
} from '@/api/analysis/custom-analysis';
import { createComponent, getBoardDetail, getComponentList, modifyComponent } from '@/api/analysis/custom-overview';

import { PollingAction } from '@/utils/helper';
import mixinGuide from '@/minxins/new-guide';
import EventModel from '@/views/analysis/distribute-analysis/components/event-model.vue';
import DistributeRegion from '@/views/analysis/distribute-analysis/components/distribute-region.vue';
import {
  DEFAULT_DATE,
  DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS,
  DISTRIBUTION_REGION_GROUP_ENUM,
  DISTRIBUTION_REGION_TYPE_ENUM,
  DEFAULT_TIME_UNIT_OPTIONS,
  DEFAULT_CHART_TYPE_OPTIONS,
  DEFAULT_CHART_SHOW_TYPE_OPTIONS,
  CHART_TYPE_OPTION,
} from '@/views/analysis/distribute-analysis/components/config';
import EventAndPropertySelector from '@/components/analysis/event-and-property-selector.vue';
import DistributeDataChart from '@/views/analysis/distribute-analysis/components/distribute-data-chart.vue';
import DistributeDataTable from '@/views/analysis/distribute-analysis/components/distribute-data-table.vue';

export default {
  name: 'DistributeAnalysis',
  mixins: [mixinGuide],
  components: {
    DistributeDataTable,
    DistributeDataChart,
    EventAndPropertySelector,
    DistributeRegion,
    EventModel,
    FormItem,
    ConditionFilter,
    noData,
    DateRangePicker,
    SaveAction,
  },
  data() {
    return {
      showAnalysisConditions: true,

      bookHref,
      loading: {
        initLoading: false,
        query: false,
        submitting: false,
        fetchData: false,
        fetchBookmark: false,
        fetchFormOption: false,
      },

      refreshCount: 0,
      showBookmarkModal: false,
      polling: null, //  轮询查询对象

      //  表单选项
      formOption: {
        eventList: [],
        conditionOperatorOptions: [
          // { type: 'eq', desc: '等于', javaType: 'string', canMore: 2 },
        ],
        conditionPropertyOptions: [],

        allEventProperty: [],

        datePickerOptions: {
          disabledDate(time) {
            return dayjs(time).isAfter(dayjs(new Date()), 'day');
          },
        },

        groupPropertyTypeOptions: DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS,
        timeUnitOptions: DEFAULT_TIME_UNIT_OPTIONS,
        chartTypeOptions: DEFAULT_CHART_TYPE_OPTIONS,
        chartShowOptions: DEFAULT_CHART_SHOW_TYPE_OPTIONS,
      },

      formValue: {
        id: undefined,

        eventModel: {
          eventName: '',
          connectors: 'and',
          conditionModelList: [],
          targetColumnModel: {
            type: '',
          },
        },
        interval: {
          type: '',
          value: '',
        },
        chartType: 'trend',

        globalFilterName: '全体用户',
        groupBy: '',
        connectors: 'and',
        conditionModels: [],

        dateInfo: DEFAULT_DATE,
      },

      analysisDataShowInfo: {
        distributionRegion: {
          type: 1,
          group: -1,
          interval: 20,
          intervalArr: [
            { start: '-∞', end: 20 },
            { start: 20, end: '+∞' },
          ],
        },

        timeUnit: 'day',
        date: [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')],
        groupPropertyType: -1,
        groupEventAndProp: {
          eventName: '',
          propertyName: '',
        },
        chartShowType: 'line',
      },

      canAutoModifyGlobalFilterName: true,

      formBookmark: {
        id: '',
        bookmarkName: '',
        remark: '',
      },
      formComponent: {
        id: '',
        name: '',
        boardId: '',
      },
      boardInfo: {},

      analysisData: null,

      resetData: {
        formValue: {
          id: undefined,

          eventModel: {
            eventName: '',
            connectors: 'and',
            conditionModelList: [],
            targetColumnModel: {
              type: '',
            },
          },
          interval: {
            type: '',
            value: '',
          },
          chartType: 'trend',

          globalFilterName: '全体用户',
          groupBy: '',
          connectors: 'and',
          conditionModels: [],

          dateInfo: DEFAULT_DATE,
        },

        analysisDataShowInfo: {
          distributionRegion: {
            type: 1,
            group: -1,
            interval: 20,
            intervalArr: [
              { start: '-∞', end: 20 },
              { start: 20, end: '+∞' },
            ],
          },

          timeUnit: 'day',
          date: [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')],
          groupPropertyType: -1,
          groupEventAndProp: {
            eventName: '',
            propertyName: '',
          },
          chartShowType: 'line',
        },
      },
    };
  },

  computed: {
    headTitle() {
      return this.formComponent.name || this.formBookmark.bookmarkName || '分布分析';
    },
    filterTimeUnitOptions() {
      if (this.formValue.eventModel.targetColumnModel.type === 'totalHours') {
        return this.formOption.timeUnitOptions.filter(option => option.value !== 'hour');
      }
      if (this.formValue.eventModel.targetColumnModel.type === 'totalDays') {
        return this.formOption.timeUnitOptions.filter(option => option.value !== 'day' && option.value !== 'hour');
      }
      return this.formOption.timeUnitOptions;
    },
    dataPickerType() {
      if (this.analysisDataShowInfo.timeUnit === 'hour') {
        return 'datetimerange';
      }
      return 'daterange';
    },
    groupEventPropPlaceholder() {
      return this.analysisDataShowInfo.groupPropertyType === 1
        ? '请选择用于分组的事件属性'
        : '请选择用于分组的用户属性';
    },
    allGroupFilterEvent() {
      return this.formValue.eventModel.eventName ? [{ eventName: this.formValue.eventModel.eventName }] : [];
    },
  },

  watch: {
    $route() {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('routerReload'));
      }, 100);
    },
    'formValue.conditionModels': {
      handler() {
        if (!this.canAutoModifyGlobalFilterName) {
          return;
        }
        this.formValue.globalFilterName =
          this.formValue.conditionModels
            .map(item => item.value)
            .filter(item => !!item)
            .join(',') || '全体用户';
      },
      deep: true,
    },
    'formValue.eventModel.targetColumnModel.type': {
      handler() {
        if (!this.formValue.eventModel.targetColumnModel.type) {
          return;
        }
        const findOption = this.filterTimeUnitOptions.find(
          option => option.value === this.analysisDataShowInfo.timeUnit,
        );
        if (!findOption) {
          this.analysisDataShowInfo.timeUnit = this.filterTimeUnitOptions[0].value;
        }
      },
      deep: true,
    },
  },

  async created() {
    this.initUrlParams();
    this.initData();
  },

  beforeDestroy() {
    if (this.polling) {
      this.polling.stop();
    }
  },

  methods: {
    initUrlParams() {
      if (this.$route.query.bookmarkId) {
        this.formBookmark.id = this.$route.query.bookmarkId;
      }
      if (this.$route.query.compId) {
        this.formComponent.id = this.$route.query.compId;
      }
      if (this.$route.query.boardId) {
        this.formComponent.boardId = this.$route.query.boardId;
      }
    },

    async initData() {
      try {
        this.loading.initLoading = true;
        try {
          await this.getFormOption();
        } catch (e) {
          this.$message.warning((e && e.message) || '系统异常，请稍后重试');
        }

        if (this.formBookmark.id) {
          await this.fetchBookmarkDetail();
          this.handleGetData();
        }
        if (this.formComponent.id) {
          await this.fetchComponentInfo();
          this.handleGetData();
        }
        if (this.formComponent.boardId) {
          await this.fetchBoardInfo();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.initLoading = false;
        // 判断是否出现新手指引
        // setTimeout(() => {
        //   this.checkGuide();
        // }, 20);
      }
    },

    async getFormOption() {
      await new Promise(resolve => {
        const allFinished = [0, 0, 0];
        this.loading.fetchFormOption = true;

        const loadingStatus = () => Math.min(...allFinished) === 0;

        getEventList({ params: { getType: 'all' } })
          .then(res => {
            this.formOption.eventList = res || [];
          })
          .finally(() => {
            allFinished[0] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getAllProperty({ params: { hasData: 1, isVisible: 1 } })
          .then(res => {
            this.formOption.conditionPropertyOptions = (res.list || []).map(item => ({
              propertyType: item.propertyType,
              propertyName: item.name,
              propertyDesc: item.chineseName,
              propertyDataType: item.javaType,
              name: item.name,
              propertyValueTipVOList: item.propertyValueTipVOList,
            }));
          })
          .finally(() => {
            allFinished[1] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getConditionOperator()
          .then(res => {
            this.formOption.conditionOperatorOptions = res;
          })
          .finally(() => {
            allFinished[2] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });
      });

      await this.getAllEventProperty();
    },

    async getAllEventProperty() {
      const res = (await getAllEventProperty({})) || [];
      this.formOption.allEventProperty = res.map(item => ({
        eventName: item.eventName,
        eventShowName: item.eventShowName,
        propertyList: (item.propertyList || []).map(i => ({
          propertyName: i.name,
          propertyDesc: i.chineseName,
          propertyType: i.propertyType,
          propertyDataType: i.javaType,
        })),
      }));
    },

    handleOpenSave() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.showBookmarkModal = true;
    },

    async fetchBookmarkDetail() {
      const { id } = this.formBookmark;

      if (!id) {
        throw new Error(`bookmark id is required, which id is ${id}}`);
      }

      this.loading.fetchBookmark = true;

      try {
        const res = await getBookmarkDetail({ params: { id } });

        this.formBookmark.bookmarkName = res.bookmarkName;
        this.formBookmark.remark = res.remark;

        this.recoverConfig(res);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.fetchBookmark = false;
      }
    },

    async fetchComponentInfo() {
      try {
        const { id } = this.formComponent;
        const retData = await getComponentList({ params: { id } });
        if (!retData || !retData.length) return;

        Object.assign(this.formComponent, retData[0]);
        const params = this.formComponent.analysisModelDetailVO || {};

        this.recoverConfig(params);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBoardInfo() {
      try {
        const res = await getBoardDetail({ params: { boardId: this.formComponent.boardId } });
        this.boardInfo = res;
        if (!this.boardInfo.componentList) {
          this.boardInfo.componentList = [];
        }
        if (!this.boardInfo.globalConditionConfigVO) {
          this.boardInfo.globalConditionConfigVO = {};
        }
      } catch (e) {
        console.error(e);
      }
    },

    // 把数据还原成页面的配置
    recoverConfig(res) {
      const pickRes = pick(res, [
        'id',
        'eventModel',
        'groupBy',
        'dateInfo',
        'chartType',
        'interval',
        'connectors',
        'conditionModels',
        'globalFilterName',
      ]);
      const formData = this.dataToForm(pickRes);
      this.formValue = formData;
    },

    validConfig() {
      const { formValue } = this;
      let validRet = true;
      const v1 = !!formValue.eventModel.eventName;
      if (!v1) {
        this.$message.warning('请选择事件');
        validRet = false;
        return validRet;
      }
      const v2 = !!formValue.eventModel.targetColumnModel.type;
      if (!v2) {
        this.$message.warning('请选择统计值');
        validRet = false;
        return validRet;
      }
      const v3 = !!formValue.dateInfo.timeDimension;
      if (!v3) {
        this.$message.warning('请选择时间单位');
        validRet = false;
        return validRet;
      }
      let v4 = true;
      if (this.analysisDataShowInfo.distributionRegion.type === 2) {
        this.analysisDataShowInfo.distributionRegion.intervalArr.forEach((item, index) => {
          if (
            index !== 0 &&
            index !== this.analysisDataShowInfo.distributionRegion.intervalArr.length - 1 &&
            item.start >= item.end
          ) {
            v4 = false;
          }
        });
      }
      if (!v4) {
        this.$message.warning('请修改自定义区间步长');
        validRet = false;
        return validRet;
      }
      return validRet;
    },

    async fetchAnalysisData(formValue) {
      this.loading.fetchData = true;

      let retData;

      try {
        const { uuid } = await getDistributePollingId({ data: formValue });
        this.polling = new PollingAction({
          delay: 2000,
          handler: async () => {
            retData = await getDistributePollingData({ params: { uuid } });
            if (!retData) return true;
            this.loading.fetchData = false;
            this.analysisData = retData;
            return false;
          },
        });

        await this.polling.start();

        if (!retData) {
          throw new Error(`retData is ${retData}`);
        }
      } catch (e) {
        console.error(e);
        this.$message.error(e.message);
        this.loading.fetchData = false;
      }
    },

    // 接口数据转化为表单数据
    dataToForm(data) {
      if (!data) return {};
      const currData = lodash.cloneDeep(data);
      const { interval, dateInfo, groupBy, eventModel } = currData;

      // type: number (0：快捷区间-默认分组 1：智能分组-指定分组 2：智能分组-自定义步长 3：自定义区间)
      const distributionRegion = {
        type: DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT,
        group: DISTRIBUTION_REGION_GROUP_ENUM.AUTO,
        interval: 20,
        intervalArr: [
          { start: '-∞', end: 20 },
          { start: 20, end: '+∞' },
        ],
      };

      if (interval.type === 0) {
        distributionRegion.type = DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT;
        distributionRegion.group = DISTRIBUTION_REGION_GROUP_ENUM.AUTO;
        distributionRegion.interval = null;
        distributionRegion.intervalArr = null;
      }
      if (interval.type === 1) {
        distributionRegion.type = DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT;
        distributionRegion.group = interval.value;
        distributionRegion.interval = interval.value;
        distributionRegion.intervalArr = null;
      }
      if (interval.type === 2) {
        distributionRegion.type = DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT;
        distributionRegion.group = DISTRIBUTION_REGION_GROUP_ENUM.CUSTOM;
        distributionRegion.interval = interval.value;
        distributionRegion.intervalArr = null;
      }
      if (interval.type === 3) {
        distributionRegion.type = DISTRIBUTION_REGION_TYPE_ENUM.CUSTOM;
        const valueArr = interval.value.split(',');
        const intervalArr = [{ start: '-∞', end: valueArr[0] }];
        for (let i = 0; i < valueArr.length - 1; i++) {
          intervalArr.push({ start: valueArr[i], end: valueArr[i + 1] });
        }
        intervalArr.push({ start: valueArr[valueArr.length - 1], end: '+∞' });
      }
      this.analysisDataShowInfo.distributionRegion = distributionRegion;

      const { timeDimension, startTime, endTime } = dateInfo.timeDimension;
      const start = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss');
      const end = dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');

      this.analysisDataShowInfo.timeUnit = timeDimension;
      this.analysisDataShowInfo.date = [start, end];

      let groupPropertyType = -1;
      let groupPropertyEventName = '';
      let groupPropertyPropertyName = '';
      if (groupBy) {
        groupPropertyEventName = eventModel.eventName;
        groupPropertyPropertyName = groupBy;

        const ep = this.formOption.allEventProperty.find(item1 => item1.eventName === eventModel.eventName) || {
          propertyList: [],
        };
        const p = ep.propertyList.find(item2 => item2.propertyName === groupBy) || { propertyType: -1 };
        groupPropertyType = p.propertyType;
      }
      this.analysisDataShowInfo.groupPropertyType = groupPropertyType;
      this.analysisDataShowInfo.groupEventAndProp.eventName = groupPropertyEventName;
      this.analysisDataShowInfo.groupEventAndProp.propertyName = groupPropertyPropertyName;

      return {
        ...currData,
      };
    },

    // 表单数据转化接口数据
    getFormData() {
      const formValue = lodash.cloneDeep(this.formValue);
      const { distributionRegion, timeUnit } = this.analysisDataShowInfo;

      const interval = { type: '', value: '' };

      if (
        distributionRegion.type === DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT &&
        distributionRegion.group === DISTRIBUTION_REGION_GROUP_ENUM.AUTO
      ) {
        interval.type = 0;
        interval.value = null;
      }

      if (
        distributionRegion.type === DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT &&
        [
          DISTRIBUTION_REGION_GROUP_ENUM.FIVE,
          DISTRIBUTION_REGION_GROUP_ENUM.TEN,
          DISTRIBUTION_REGION_GROUP_ENUM.FIFTEEN,
        ].includes(distributionRegion.group)
      ) {
        interval.type = 1;
        interval.value = distributionRegion.interval;
      }

      if (
        distributionRegion.type === DISTRIBUTION_REGION_TYPE_ENUM.DEFAULT &&
        distributionRegion.group === DISTRIBUTION_REGION_GROUP_ENUM.CUSTOM
      ) {
        interval.type = 2;
        interval.value = distributionRegion.interval;
      }

      if (distributionRegion.type === DISTRIBUTION_REGION_TYPE_ENUM.CUSTOM) {
        let value = distributionRegion.intervalArr.map(item => `${item.start}`);
        value = value.slice(1, value.length).join(',');
        interval.type = 3;
        interval.value = value;
      }

      const { dateInfo } = formValue;
      dateInfo.timeDimension = timeUnit;
      let fm = 'YYYYMMDD';
      if (timeUnit === 'hour') {
        fm = 'YYYYMMDDHH';
      }
      dateInfo.startTime = dayjs(this.analysisDataShowInfo.date[0]).format(fm);
      dateInfo.endTime = dayjs(this.analysisDataShowInfo.date[1]).format(fm);

      return {
        ...formValue,
        interval,
        dateInfo,
      };
    },

    handleQueryClick() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      const formValue = this.getFormData();
      this.fetchAnalysisData(formValue);
    },

    handleGetData() {
      const formValue = this.getFormData();
      this.fetchAnalysisData(formValue);
    },

    async handleSaveBookmark(form) {
      try {
        const { id, bookmarkName, remark } = form;
        const params = {
          ...{
            id,
            bookmarkName,
            remark,
          },
          analysisType: 'distribution',
          attributionAnalysisReq: this.getFormData(),
        };

        this.loading.submitting = true;
        const retData = await saveAsBookmark({ data: params });

        this.$message.success('保存成功');

        this.showBookmarkModal = false;

        this.$router.replace({
          name: 'UserPathAnalysis',
          query: {
            bookmarkId: params.id || retData,
          },
        });
      } catch (e) {
        //
      } finally {
        this.loading.submitting = false;
      }
    },

    async handleSaveComponent(type, form) {
      const analysisModelReq = this.getFormData();

      const params = {
        analysisType: 'distribution',
        analysisModelReq: JSON.stringify(analysisModelReq),
      };

      const propArr = ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext', 'lineCount'];

      const tmpObj = pick(form, propArr);
      Object.assign(params, tmpObj);

      try {
        this.loading.submitting = true;

        if (type === 'new') {
          await createComponent({ data: params });
        } else {
          await modifyComponent({ data: params });
        }

        this.$message.success('保存成功');
        this.showBookmarkModal = false;

        setTimeout(() => {
          this.$router.replace({
            name: 'OverviewHome',
            query: {
              boardId: params.boardId,
            },
          });
        }, 100);
      } finally {
        this.loading.submitting = false;
      }
    },

    handleAddGlobalFilterItem() {
      if (this.formValue.conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.formValue.conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },

    onPropertyTypeChange() {
      this.analysisDataShowInfo.groupEventAndProp.eventName = '';
      this.analysisDataShowInfo.groupEventAndProp.propertyName = '';
    },

    handleChangeTimeUnit() {
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    handleChangeDate() {
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    handleChangeChartType() {
      if (this.formValue.chartType === 'group') {
        this.analysisDataShowInfo.chartShowType = 'line';
      }
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    getGroupOptionLabelFormat({ eventProperty }) {
      return eventProperty.eventShowName;
    },

    getGroupOptionValueFormat({ index, eventProperty }) {
      return eventProperty.eventName || '';
    },

    handleGroupEventAndPropChange(val) {
      this.formValue.groupBy = val.propertyName;
    },

    backup$Data() {
      this.$set(this.resetData, 'formValue', lodash.cloneDeep(this.formValue));
      this.$set(this.resetData, 'analysisDataShowInfo', lodash.cloneDeep(this.analysisDataShowInfo));
    },

    handleReset() {
      const formValue = lodash.cloneDeep(this.resetData.formValue);
      const analysisDataShowInfo = lodash.cloneDeep(this.resetData.analysisDataShowInfo);
      this.$set(this.$data, 'formValue', formValue);
      this.$set(this.$data, 'analysisDataShowInfo', analysisDataShowInfo);
    },

    handleBack() {
      this.$router.replace({
        name: 'OverviewHome',
        query: {
          boardId: this.formComponent.boardId,
        },
      });
    },

    handleGlobalFilterNameChange() {
      this.canAutoModifyGlobalFilterName = !this.formValue.globalFilterName;
      if (this.canAutoModifyGlobalFilterName) {
        this.formValue.globalFilterNam =
          this.formValue.conditionModels
            .map(item => item.value)
            .filter(item => !!item)
            .join(',') || '全体用户';
      }
    },

    async checkGuide() {
      const me = this;
      const code = 'CustomZone.GuiyinAnalysis.FirstVisit';
      this.guideDriver = this.initGuideDriver({
        onReset() {
          me.setVisitedStatus(code, 1);
        },
      });
      this.initGuideSteps();
      const isVisited = await this.getVisitedStatus(code);
      if (!isVisited) {
        this.guideDriver.start();
      }
    },

    initGuideSteps() {
      const me = this;
      const { guideDriver } = this;
      guideDriver.defineSteps([
        {
          element: '.new-guide-step-1',
          popover: {
            className: 'first-step-popover-class',
            closeBtnText: '跳过(1/5)',
            title: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
            description: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
          },
        },
        {
          element: '.new-guide-step-2',
          popover: {
            closeBtnText: '跳过(2/5)',
            title: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
            description: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
          },
        },
        {
          element: '.new-guide-step-3',
          popover: {
            closeBtnText: '跳过(3/5)',
            title: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
            description: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
          },
        },
        {
          element: '.new-guide-step-4',
          popover: {
            closeBtnText: '跳过(4/5)',
            title: '这里可限定待归因事件到目标转化事件之间的最长时间',
            description: '这里可限定待归因事件到目标转化事件之间的最长时间',
          },
        },
        {
          element: '.new-guide-step-5',
          popover: {
            closeBtnText: '跳过(5/5)',
            title: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
            description: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
          },
          onNext() {
            me.highlightTriggerElement();
          },
        },
      ]);
    },

    handleStartGuide() {
      this.guideDriver.start();
    },

    exportData() {
      const fileName = '分析结果.xlsx';
      const data = [];
      const title = ['事件/日期', '全局筛选', '区间', '分组', '总和', '平均值'];

      const { analysisData } = this;
      if (!analysisData) {
        return;
      }

      const { chartType } = this.formValue;
      const { dateList, distributionScopeList } = analysisData;

      const fieldList = chartType === 'trend' ? dateList : distributionScopeList;

      if (!fieldList || !fieldList.length) {
        return;
      }

      fieldList.forEach((item, index) => {
        title.push(item);
      });

      data.push(title);

      analysisData.dataItemList.forEach(dataItem => {
        const row = [
          `A1 ${analysisData.eventName}`,
          dataItem.globalFilterName,
          dataItem.distributionScope,
          dataItem.groupByKey,
          data.dataSum,
          data.dataAvg,
        ];
        dataItem.data.forEach(subDataItem => {
          row.push(subDataItem);
        });

        data.push(row);
      });

      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '分布分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style scoped lang="less">
@import 'distribute-analysis.less';
</style>
